export function checkSessionStatus({ isCanceled = false, enrollments = [] }) {
  return {
    isCanceled: isCanceled,
    isPaid: enrollments.some(e => e.transactions?.some(t => !t.refund)),
    isLessonCredit: enrollments.some(e => e.lessonCredit),
  }
}

export function getLessonPackReceiptId(enrollment) {
  const payments = enrollment?.lessonCredit?.lessonPack?.registrationPayments
  if (!payments?.length) return null

  // Packs typically have one purchase. If several exist (retry or partial pay),
  // use the earliest createdAt so View Transaction opens the original receipt.
  const original = payments.reduce((earliest, payment) => {
    if (!payment?.createdAt) return earliest
    if (!earliest?.createdAt) return payment
    return new Date(payment.createdAt) < new Date(earliest.createdAt)
      ? payment
      : earliest
  })

  return original?.id ?? payments[0].id
}

export function getLessonPackReceiptIdFromEnrollments(enrollments = []) {
  for (const enrollment of enrollments) {
    const receiptId = getLessonPackReceiptId(enrollment)
    if (receiptId) return receiptId
  }
  return null
}

const mergeLessonCredit = (fromLesson, fromEnrollment) => {
  if (!fromLesson) return fromEnrollment
  if (!fromEnrollment) return fromLesson

  const registrationPayments = fromLesson.lessonPack?.registrationPayments
    ?.length
    ? fromLesson.lessonPack.registrationPayments
    : fromEnrollment.lessonPack?.registrationPayments

  return {
    ...fromEnrollment,
    ...fromLesson,
    lessonPack: {
      ...fromEnrollment.lessonPack,
      ...fromLesson.lessonPack,
      ...(registrationPayments ? { registrationPayments } : null),
    },
  }
}

export function withEnrollmentCredit(lesson, enrollment) {
  if (!lesson?.enrollments || !enrollment?.id) return lesson

  return {
    ...lesson,
    enrollments: lesson.enrollments.map(item =>
      item.id === enrollment.id
        ? {
          ...item,
          lessonCredit: mergeLessonCredit(
            item.lessonCredit,
            enrollment.lessonCredit,
          ),
        }
        : item,
    ),
  }
}

export const SESSION_CHIP_VARIANTS = {
  CANCELED: 'canceled',
  LESSON_CREDIT: 'lessonCredit',
  PAID: 'paid',
  UNPAID: 'unpaid',
}

// Can be used if only one status chip is being displayed.
export function sessionChipStatus({ isCanceled, isPaid, isLessonCredit }) {
  if (isCanceled) return 'Canceled'
  if (isLessonCredit) return 'Credit Redeemed'
  return isPaid ? 'Paid' : 'Unpaid'
}

export function sessionChipVariant({ isCanceled, isPaid, isLessonCredit }) {
  if (isCanceled) return SESSION_CHIP_VARIANTS.CANCELED
  if (isLessonCredit) return SESSION_CHIP_VARIANTS.LESSON_CREDIT
  if (isPaid) return SESSION_CHIP_VARIANTS.PAID
  return SESSION_CHIP_VARIANTS.UNPAID
}
